import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconWrapper } from '@flexo/general';
import styles from './password-conditions.module.scss';

export interface PasswordValidation {
  lengthValid: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
  hasUpperCase: boolean;
  hasLowerCase: boolean;
  passwordsMatch: boolean;
}

export interface PasswordConditionsProps {
  validation: PasswordValidation;
  isFocused?: boolean;
  className?: string;
  conditionClassName?: string;
  showPasswordMatch?: boolean;
}

export function PasswordConditions({
  validation,
  isFocused = false,
  className,
  conditionClassName,
  showPasswordMatch = false,
}: PasswordConditionsProps) {
  const { t } = useTranslation();

  const getIcon = (value: boolean) => {
    // If it's a valid condition, always show check_encircled
    if (value) return 'check-encircled_outline';

    // For invalid conditions, show empty_circle when focused, cross_encircled when blurred
    if (isFocused) return 'circle';
    return 'cross_encircled';
  };

  const conditionsToShow = showPasswordMatch
    ? Object.entries(validation)
    : Object.entries(validation).filter(([key]) => key !== 'passwordsMatch');

  return (
    <div className={`${styles.PasswordConditions} ${className || ''}`}>
      {conditionsToShow.map(([key, value]) => (
        <div key={key} className={`${styles.PasswordConditions__Item} `}>
          <span className={styles.PasswordConditions__Icon}>
            <IconWrapper iconName={getIcon(value)} />
          </span>
          <span className={styles.PasswordConditions__Text}>
            {t(`pages.forgotten_password.validation.${key}`)}
          </span>
        </div>
      ))}
    </div>
  );
}

export default PasswordConditions;
